import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "animate.css";
import "./Volunteer.css";

import Navbar from "../../Navbar/Navbar";
import Footer from "../../Footer/Footer";
import { GetInvolvedData } from "../../Data/GetInvolvedData";

const ROTATE_INTERVAL = 5000;

const impactCategories = [
    {
        id: "education",
        title: "Education & Skills",
        stat: "65+ learners completed Functional Skills this year",
        images: [
            { src: "programs/education-support.png", alt: "Education Support in a classroom setting" },
            { src: "people/moments/community-moment-2.jpg", alt: "Education and skills training session" },
            { src: "people/moments/community-moment-7.jpg", alt: "Community learning moment" },
            { src: "people/moments/community-moment-wa-2.jpg", alt: "Women's education session" },
            { src: "people/training/training-session-1.jpg", alt: "Training session in progress" },
            { src: "people/training/training-session-18.jpg", alt: "Skills development workshop" }
        ]
    },
    {
        id: "advocacy",
        title: "Advocacy & Rights",
        stat: "Helping secure £45,000+ in vital benefits",
        images: [
            { src: "volunteer/advocacy-support.png", alt: "Advocacy Support one-on-one session" }
        ]
    },
    {
        id: "employment",
        title: "Employment Success",
        stat: "45.7% job success rate for participants",
        images: [
            { src: "programs/employment-support.jpg", alt: "Employment Mentorship workshop" },
            { src: "people/training/training-session-13.jpg", alt: "Employment support training" },
            { src: "people/moments/community-moment-wa-1.jpg", alt: "Career development moment" },
            { src: "people/training/training-session-7.jpg", alt: "Job skills training session" }
        ]
    },
    {
        id: "community",
        title: "Community Connection",
        stat: "Fostering bonds and reducing isolation",
        images: [
            { src: "programs/community-connection.png", alt: "Community Connection gathering" },
            { src: "people/training/training-session-19.jpg", alt: "Community training session" },
            { src: "people/training/training-session-20.jpg", alt: "Community workshop" },
            { src: "people/training/training-session-27.jpg", alt: "Group collaboration session" },
            { src: "people/training/workshop-collaboration.jpg", alt: "Workshop collaboration" }
        ]
    },
    {
        id: "youth",
        title: "Youth & Coding Camp",
        stat: "Inspiring the next generation of digital creators",
        images: [
            { src: null, placeholder: "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?auto=format&fit=crop&w=600&q=80", alt: "Youth coding workshop" },
            { src: "people/moments/community-moment-4.jpg", alt: "Coding camp youth session" },
            { src: "people/moments/community-moment-5.jpg", alt: "Young learners at coding camp" },
            { src: "coding-camp/IMG_3130.jpg", alt: "Coding camp activity" },
            { src: "coding-camp/IMG_3131.jpg", alt: "Coding camp workshop" },
            { src: "coding-camp/IMG_3132.jpg", alt: "Youth coding session" },
            { src: "coding-camp/IMG_3133.jpg", alt: "Coding camp learning" },
            { src: "coding-camp/IMG_3134.jpg", alt: "Digital skills training" },
            { src: "coding-camp/IMG_3135.jpg", alt: "Coding camp students" },
            { src: "coding-camp/IMG_3136.jpg", alt: "Youth programming workshop" },
            { src: "coding-camp/IMG_3137.jpg", alt: "Coding camp group" },
            { src: "coding-camp/IMG_3138.jpg", alt: "Tech education session" },
            { src: "coding-camp/IMG_3139.jpg", alt: "Coding class" },
            { src: "coding-camp/IMG_3142.jpg", alt: "Youth tech workshop" },
            { src: "coding-camp/IMG_3143.jpg", alt: "Coding camp activities" },
            { src: "coding-camp/IMG_3144.jpg", alt: "Programming for youth" },
            { src: "coding-camp/IMG_3146.jpg", alt: "Digital creation workshop" },
            { src: "coding-camp/IMG_3151.jpg", alt: "Coding camp moment" },
            { src: "coding-camp/IMG_3152.jpg", alt: "Youth learning code" },
            { src: "coding-camp/IMG_3154.jpg", alt: "Coding session" },
            { src: "coding-camp/IMG_3156.jpg", alt: "Tech camp activities" },
            { src: "coding-camp/IMG_3167.jpg", alt: "Coding camp in action" },
            { src: "coding-camp/IMG_9862.jpg", alt: "Youth coding program" }
        ]
    },
    {
        id: "women",
        title: "Women's Programs",
        stat: "Empowering women through support and skills",
        images: [
            { src: "people/moments/community-moment-3.jpg", alt: "Women's community moment" },
            { src: "people/training/training-session-8.jpg", alt: "Women's training session" },
            { src: "people/events/womens-day-celebration.jpg", alt: "International Women's Day celebration" },
            { src: "people/events/thank-you-board.jpg", alt: "Thank you board from women participants" }
        ]
    }
];

const Volunteer = () => {
    const pageData = GetInvolvedData.volunteer;
    const [categoryImages, setCategoryImages] = useState({});
    const [activeIndices, setActiveIndices] = useState({});
    const [activeCategory, setActiveCategory] = useState("All");
    const [socialDialogOpen, setSocialDialogOpen] = useState(false);

    const socialLinks = {
        facebook: "https://www.facebook.com/AlisarProspectsTrainingCIC/",
        instagram: "https://www.instagram.com/apt_cic/?hl=en-gb"
    };

    const openSocialLink = (platform) => {
        window.open(socialLinks[platform], '_blank', 'noopener,noreferrer');
        setSocialDialogOpen(false);
    };

    useEffect(() => {
        const loadImages = async () => {
            const loadedImages = {};
            for (const category of impactCategories) {
                loadedImages[category.id] = [];
                for (const img of category.images) {
                    if (img.placeholder) {
                        loadedImages[category.id].push(img.placeholder);
                    } else if (img.src) {
                        try {
                            const imported = await import(`../../../images/${img.src}`);
                            loadedImages[category.id].push(imported.default);
                        } catch (e) {
                            loadedImages[category.id].push(null);
                        }
                    }
                }
            }
            setCategoryImages(loadedImages);
            
            const initialIndices = {};
            impactCategories.forEach(cat => {
                initialIndices[cat.id] = 0;
            });
            setActiveIndices(initialIndices);
        };

        loadImages();
    }, []);

    useEffect(() => {
        if (Object.keys(categoryImages).length === 0) return;
        
        const interval = setInterval(() => {
            setActiveIndices(prev => {
                const next = { ...prev };
                impactCategories.forEach(cat => {
                    const imageCount = categoryImages[cat.id]?.filter(Boolean).length || 1;
                    if (imageCount > 1) {
                        next[cat.id] = (prev[cat.id] + 1) % imageCount;
                    }
                });
                return next;
            });
        }, ROTATE_INTERVAL);

        return () => clearInterval(interval);
    }, [categoryImages]);

    // Helper Icons with aria-labels for accessibility
    const CheckIcon = () => (
        <svg aria-label="Check mark" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
            <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
    );

    const TimeIcon = () => (
        <svg aria-label="Time commitment" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
            <circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>
        </svg>
    );

    const SkillIcon = () => (
        <svg aria-label="Skills needed" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
        </svg>
    );

    const ImpactIcon = () => (
        <svg aria-label="Impact" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
    );

    // Dynamic Benefit Icons
    const BenefitIcons = {
        impact: () => <svg aria-label="Community Impact" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="36" height="36"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>,
        career: () => <svg aria-label="Career Growth" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="36" height="36"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>,
        skills: () => <svg aria-label="Lived Experience" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="36" height="36"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>,
        connection: () => <svg aria-label="Build Connections" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="36" height="36"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>,
        flexibility: () => <svg aria-label="Flexible Hours" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="36" height="36"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
    };

    const categories = ["All", "Education", "Community", "Professional", "Flexible"];
    
    // Categorize roles logic
    const filteredRoles = pageData.volunteerRoles.filter(role => {
        if (activeCategory === "All") return true;
        if (activeCategory === "Education" && (role.role.includes("ESOL") || role.role.includes("Digital"))) return true;
        if (activeCategory === "Community" && (role.role.includes("Ambassador") || role.role.includes("Event") || role.role.includes("Interpreter"))) return true;
        if (activeCategory === "Professional" && (role.role.includes("Pro Bono") || role.role.includes("Mentor") || role.role.includes("Administrative"))) return true;
        if (activeCategory === "Flexible" && (role.timeCommitment.toLowerCase().includes("flexible") || role.timeCommitment.toLowerCase().includes("ad-hoc"))) return true;
        return false;
    });

    return (
        <div>
            <Navbar />

            <div className="volunteer-container">
                {/* 1. HERO SECTION */}
                <section className="volunteer-hero">
                    <img 
                        src={categoryImages.education?.[0] || "https://images.unsplash.com/photo-1559027615-cd4628902d4a?auto=format&fit=crop&w=1920&q=80"} 
                        alt="Volunteer teaching adult learners in East London" 
                        className="volunteer-hero-bg" 
                    />
                    <div className="volunteer-hero-overlay"></div>
                    <div className="volunteer-hero-content animate__animated animate__fadeInUp">
                        <div className="hero-stat-badge">750+ people reached this year</div>
                        <div className="volunteer-hero-card">
                            <h1>{pageData.pageTitle}</h1>
                            <p>{pageData.tagline}. Every hour you give translates into real-world impact for individuals and families in East London.</p>
                            <div className="hero-cta-group">
                                <Link to="/contact?subject=Volunteer Application" className="volunteer-btn-primary">Apply to Volunteer</Link>
                                <a href="#roles" className="volunteer-btn-secondary">See Current Roles ↓</a>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 2. WHY VOLUNTEER (Value Props) */}
                {pageData.whyVolunteer && (
                    <section className="why-volunteer-section">
                        <div className="impact-counter-row">
                            <div className="impact-counter">
                                <h3>200+</h3>
                                <p>Active Participants</p>
                            </div>
                            <div className="impact-counter">
                                <h3>16</h3>
                                <p>Moved into Employment</p>
                            </div>
                            <div className="impact-counter">
                                <h3>170+</h3>
                                <p>Advocacy Cases Supported</p>
                            </div>
                        </div>

                        <h2 className="section-title">Why Volunteer With Us?</h2>
                        <p className="section-subtitle">It's more than just giving time. It's about transformation.</p>

                        <div className="benefits-grid">
                            {pageData.whyVolunteer.slice(0, 4).map((benefit, index) => {
                                const IconComponent = BenefitIcons[benefit.icon] || BenefitIcons.flexibility;
                                return (
                                    <div key={index} className="benefit-card animate__animated animate__zoomIn" style={{ animationDelay: `${index * 0.1}s` }}>
                                        <div className="benefit-icon-wrapper">
                                            <IconComponent />
                                        </div>
                                        <h3>{benefit.title}</h3>
                                        <p>{benefit.description || benefit}</p>
                                    </div>
                                );
                            })}
                        </div>
                        
                        <div className="volunteer-testimonial">
                            <blockquote>"Volunteering at APT gave me purpose after I was granted asylum. Now I help others like me navigate the systems I once struggled with."</blockquote>
                            <cite>— Former Client & Volunteer</cite>
                        </div>
                    </section>
                )}

                {/* 4. IMPACT GALLERY (Visual Storytelling) */}
                <section className="impact-gallery-section">
                    <h2 className="section-title">See Your Impact</h2>
                    <p className="section-subtitle">Real moments of connection, advocacy, and growth across our programs.</p>

                    <div className="image-gallery-grid">
                        {impactCategories.map((category) => {
                            const imgs = categoryImages[category.id] || [];
                            const currentIndex = activeIndices[category.id] || 0;
                            
                            return (
                                <div key={category.id} className="gallery-item">
                                    <div className="gallery-images-container">
                                        {imgs.map((img, imgIndex) => (
                                            <img 
                                                key={imgIndex}
                                                src={img || "https://images.unsplash.com/photo-1559027615-cd4628902d4a?auto=format&fit=crop&w=600&q=80"}
                                                alt={category.images[imgIndex]?.alt || category.title}
                                                className={`gallery-image ${imgIndex === currentIndex ? 'active' : ''}`}
                                            />
                                        ))}
                                    </div>
                                    <div className="gallery-overlay">
                                        <h4>{category.title}</h4>
                                        <p>{category.stat}</p>
                                    </div>

                                </div>
                            );
                        })}
                    </div>
                </section>

                {/* 5. ROLES / OPPORTUNITIES */}
                {pageData.volunteerRoles && (
                    <section id="roles" className="roles-section">
                        <h2 className="section-title">Current Opportunities</h2>
                        <p className="section-subtitle">Find a role that matches your schedule and expertise.</p>

                        <div className="roles-filter">
                            {categories.map(category => (
                                <button 
                                    key={category} 
                                    className={`filter-btn ${activeCategory === category ? 'active' : ''}`}
                                    onClick={() => setActiveCategory(category)}
                                >
                                    {category}
                                </button>
                            ))}
                        </div>

                        <div className="roles-grid">
                            {filteredRoles.map((role, index) => {
                                const isHighNeed = role.role.includes("ESOL") || role.role.includes("Mentor") || role.role.includes("Interpreter") || role.role.includes("Advocacy");
                                
                                return (
                                    <div key={index} className="role-card">
                                        <div className="role-header">
                                            <div className="role-header-top">
                                                {isHighNeed && <span className="badge-high-need">High Need</span>}
                                            </div>
                                            <h3>{role.role}</h3>
                                            <p className="role-desc">{role.description}</p>
                                        </div>
                                        <div className="role-details">
                                            {role.timeCommitment && (
                                                <div className="detail-row">
                                                    <div className="detail-icon"><TimeIcon /></div>
                                                    <div className="detail-text">
                                                        <strong>Time Commitment</strong>
                                                        <span>{role.timeCommitment}</span>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="detail-row">
                                                <div className="detail-icon"><SkillIcon /></div>
                                                <div className="detail-text">
                                                    <strong>Skills Needed</strong>
                                                    <span>{role.skillsNeeded}</span>
                                                </div>
                                            </div>
                                            <div className="detail-row">
                                                <div className="detail-icon"><ImpactIcon /></div>
                                                <div className="detail-text">
                                                    <strong>Your Impact</strong>
                                                    <span>{role.impact}</span>
                                                </div>
                                            </div>
                                            {role.idealFor && (
                                                <div className="detail-row ideal-for-row">
                                                    <div className="detail-text">
                                                        <span className="ideal-for-badge">Best For: {role.idealFor}</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="role-footer">
                                            <Link to={`/contact?subject=Applying for ${role.role} Role`} className="role-apply-btn">Express Interest</Link>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        
                        <div className="roles-helper">
                            <p>Not sure which role is right for you? <Link to="/contact">Contact us</Link> for an informal chat.</p>
                        </div>
                    </section>
                )}

                {/* 6. VOLUNTEER SUPPORT & PROCESS (Side by Side) */}
                {(pageData.volunteerSupport || pageData.howToVolunteer) && (
                    <section className="volunteer-support-process-section">
                        <div className="support-process-grid">
                            {pageData.howToVolunteer && (
                                <div className="process-column">
                                    <h2 className="column-title">Your Volunteering Journey</h2>
                                    <p className="column-subtitle">Easy, supported, and straightforward.</p>
                                    
                                    <div className="process-timeline">
                                        {pageData.howToVolunteer.process.map((step, idx) => (
                                            <div key={idx} className="process-step">
                                                <div className="step-number">{idx + 1}</div>
                                                <div className="step-content">
                                                    <p>{step}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {pageData.volunteerSupport && (
                                <div className="support-column">
                                    <h2 className="column-title">How We Support You</h2>
                                    <p className="column-subtitle">{pageData.volunteerSupport.description}</p>
                                    
                                    <ul className="support-list">
                                        {pageData.volunteerSupport.whatWeOffer.map((offer, idx) => (
                                            <li key={idx}>
                                                <div className="support-icon"><CheckIcon /></div>
                                                <span>{offer}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </section>
                )}

                {/* 8. FINAL CTA */}
                <section className="volunteer-cta-section">
                    <div className="cta-content-box">
                        <h2>Ready to Join Us?</h2>
                        <p>Get in touch to discuss volunteer opportunities, training, and how you can be a part of the APT mission.</p>
                        <p className="cta-reassurance">No experience necessary in many roles • DBS check provided free • Full training included</p>
                        
                        <div className="final-cta-actions">
                            <Link to="/contact?subject=Volunteer Application" className="volunteer-btn-primary">Start Your Journey Today</Link>
                        </div>
                        
                        <div className="secondary-engagements">
                            <p>Not ready to volunteer just yet?</p>
                            <div className="secondary-links">
                                <button className="link-button" onClick={() => setSocialDialogOpen(true)}>Follow us on Social Media</button>


                            </div>
                        </div>

                        {/* Social Media Dialog */}
                        {socialDialogOpen && (
                            <div className="social-dialog-overlay" onClick={() => setSocialDialogOpen(false)}>
                                <div className="social-dialog" onClick={e => e.stopPropagation()}>
                                    <h3>Follow us on Social Media</h3>
                                    <p>Stay updated with our latest news and events</p>
                                    <div className="social-platforms">
                                        <button className="social-platform-btn facebook" onClick={() => openSocialLink('facebook')}>
                                            <i className="lab la-facebook"></i>
                                            Facebook
                                        </button>
                                        <button className="social-platform-btn instagram" onClick={() => openSocialLink('instagram')}>
                                            <i className="lab la-instagram"></i>
                                            Instagram
                                        </button>
                                    </div>
                                    <button className="social-dialog-close" onClick={() => setSocialDialogOpen(false)}>✕</button>
                                </div>
                            </div>
                        )}
                    </div>
                </section>

            </div>

            <Footer />
        </div>
    );
};

export default Volunteer;
